<template>
  <div>
    <p><strong>Inhaltsverzeichnis</strong></p>
    <ul class="fa-ul pb-3">
      <li v-for="(faq, index) in faqs" :key="index">
        <span class="fa-li"><i class="fas fa-arrow-circle-right"></i></span>
        <a @click="jumpToId(faq.question)">{{ faq.question }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FAQsTableOfContents',
  props: {
    faqs: { type: Array, required: true }
  },
  methods: {
    jumpToId (question) {
      const id = question.replace(/\s+/g, '-')
      document.getElementById(id).scrollIntoView(true)
      this.$matomo && this.$matomo.trackEvent(this.$router.currentRoute.path, 'jump-to', id, 0)
    }
  }
}
</script>
